/**
 * Created by mac on 9/25/20
 */

const LevelStatistics = function () {
    DataSource.call(this);
};

LevelStatistics.prototype = Object.create(DataSource.prototype);
LevelStatistics.prototype.constructor = LevelStatistics;

LevelStatistics.prototype.calculateData = function (adminLevel, f) {
    const episodeNo = adminLevel.episodeNo;
    const levelNo = adminLevel.levelNo;

    if (cleverapps.config.type === "merge") {
        return;
    }

    const activeVersion = adminLevel.getActiveVersion();

    new ActionPlayer([
        (callback) => {
            cleverapps.RestClient.get(EpisodeStatistics.getStatisticsUrl({ episode: episodeNo, level: levelNo }), {}, (response) => {
                this.data = response.filter((line) => typeof line.version === "number")
                    .sort((a, b) => b.version - a.version)
                    .map((line) => {
                        for (const key in line) {
                            line[key] = Math.round(line[key]);
                        }

                        delete line.episode;
                        delete line.level;

                        this.addPredictionData(adminLevel, line);

                        return line;
                    });

                if (!this.data.some((line) => line.version === activeVersion)) {
                    this.data.unshift({ version: activeVersion, statistics: "not ready" });
                    this.addPredictionData(adminLevel, this.data[0]);
                }

                callback();
            }, () => {
                console.log("Error getting statistics for level", adminLevel);

                this.data = [{ version: activeVersion, statistics: "request failed" }];
                this.addPredictionData(adminLevel, this.data[0]);
                callback();
            });
        },

        (f) => {
            const file = cleverapps.administrator.adminEpisodes.getActive().getLevelsFile();

            cleverapps.git.getLastCommit({ file, level: levelNo }, (response) => {
                if (response.error || !response.author || !this.data.length) {
                    f();
                    return;
                }

                const date = new Date(response.date).toLocaleDateString("ru-RU", { day: "2-digit", month: "2-digit", year: "2-digit" });

                this.data[0].commit = {
                    text: `${response.author} ${date}`,
                    url: response.url
                };

                f();
            }, f);
        }
    ]).play(f);
};

LevelStatistics.prototype.addPredictionData = function (adminLevel, data) {
    if (adminLevel.rate) {
        data.rate = adminLevel.rate;
    }

    if (cleverapps.config.type === "crossmath") {
        const puzzle = adminLevel.content;
        const w = puzzle.bounds.maxX - puzzle.bounds.minX + 1;
        const h = puzzle.bounds.maxY - puzzle.bounds.minY + 1;
        data.size = `${w}/${h}`;
        data["tray/equ"] = `${puzzle.tray.length}/${puzzle.equations.length}`;
        data[puzzle.difficulty] = puzzle.score;
    }

    if (cleverapps.config.subtype === "stacks") {
        data.wordsNo = adminLevel.words.length;
        data.letters = adminLevel.words.reduce((a, c) => a + c.length, 0);

        data.hardness = BlockMixer.predictHardness(adminLevel.words);

        PseudoRandom.GET().seed(0);
        const mixer = new BlockMixer({
            quick: true
        });

        for (let i = 0; i < 10; i++) {
            const position = mixer.mix(adminLevel.words, {
                details: true
            });
            const res = mixer.calculate(position);
            if (res !== -1) {
                data.operations = Math.round(res);
                break;
            }
        }
    }
};
